module.exports = __webpack_public_path__ + "img/bldc_cmp.405ecb46.png";